import React from "react";
import { SlovHeader } from "./doomHeader";
import { useEffect, useState, useRef } from "react";

export const DoomThinkScreen = (props) => {
    const refName = useRef(null);

    useEffect(() => {
        const elementName = refName.current;
        props.CBcolor("#777777");
    }, []);

    const [slovtext, setslovtext] = useState("");
    const [charCount, setCharCount] = useState(45);
    const [lineCount, setLineCount] = useState(1);
    const [showInspiration, setShowInspiration] = useState(false);

    const handleInputChange = (e) => {
        const inputText = e.target.value;
        const newLineCount = (inputText.match(/\n/g) || []).length + 1;

        if (inputText.length <= 45 && newLineCount <= 1) {
            setslovtext(inputText);
            setCharCount(45 - inputText.length);
            setLineCount(newLineCount);
        }
    };

    const isInputEmpty = slovtext.trim() === "";

    return (
        <div id="game">
            <SlovHeader />

            <img src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/prot/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"} alt="Player Avatar" />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />
            <div className="divtext_slov"><b>({props.TextString} из 2)</b></div>
            <p style={{ fontSize: '18px', color: 'black' }}>Назовите 2 любимых вещи/предмета/события</p>
            <br />
            <textarea
                autoComplete="off"
                className="FormInput"
                style={{ width: '80%', height: '2em' }}
                ref={refName}
                placeholder="Сообщение"
                maxLength="45"
                value={slovtext}
                onChange={handleInputChange}
            ></textarea>
            <div className="charCount" style={{ color: 'black' }}>Осталось символов: {charCount}</div>
            <br />
            <button
                type="button"
                disabled={isInputEmpty}
                onClick={(e) => {
                    if (slovtext.length <= 45 && lineCount <= 1) {
                        props.sendMessage(`sendtoserver|slov\\addtext\\${props.TextString}\\` + slovtext);
                        console.log(slovtext);
                        setslovtext("");
                        setCharCount(45);
                        setLineCount(1);
                        setShowInspiration(false)
                    }
                }}
            >
                Отправить
            </button>
            <br />
            {!showInspiration ? (
                <button
                    type="button"
                    style={{ fontSize: "14px", padding: "6px 12px", marginTop: "10px" }}
                    onClick={() => setShowInspiration(true)}
                >
                    Вдохновите меня
                </button>
            ) : (
                <div style={{ marginTop: "10px", color: "black", fontStyle: "italic", fontSize: "15px" }}>
                    {props.TextString2}
                </div>
            )}
        </div>
    );
};
